// @ts-nocheck

export const localeCodes =  [
  "pl"
]
export const localeLoaders = {
  pl: [
    {
      key: "locale_pl_46json_c5e48d49",
      load: () => import("#nuxt-i18n/c5e48d49" /* webpackChunkName: "locale_pl_46json_c5e48d49" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "pl",
    language: "pl-PL",
    name: "Polski"
  }
]

